'use client'

import { mixpanelInit } from '@repo/app-assets/Mixpanel'
import { RouterProvider } from 'react-router-dom'
import { Theme } from '@repo/theme/theme'
import AppInsightsInit from '@repo/app-assets/ApplicationInsights'
import AppRouter from '@repo/app-assets/AppRouter'
import React from 'react'
import ReactDOM from 'react-dom/client'
import routes from './routing/routes'
import '@fontsource/poppins/400.css'
import '@fontsource/poppins/500.css'
import '@fontsource/poppins/600.css'
import '@fontsource/mulish/400.css'
import '@fontsource/mulish/500.css'
import '@fontsource/mulish/600.css'
import '@repo/theme/globalStyles.scss'
import '@szhsin/react-menu/dist/index.css'
import '@szhsin/react-menu/dist/transitions/slide.css'
import { LicenseInfo } from '@mui/x-license'
LicenseInfo.setLicenseKey(import.meta.env.VITE_SPA_OSPREY_MUI_X_LICENSE_KEY)
import { useGlobalSettingsStore } from '@repo/store/useGlobalSettingsStore'
const { companyCode, databaseSuffix } = useGlobalSettingsStore.getState().getDomainDetails()

// log the version number to the console for testing purposes
import packageJson from '../package.json'

const build = import.meta.env.VITE_SPA_OSPREY_BUILD_NUMBER || 'N/A' // this env var is set in CI/CD
const version = packageJson.version

console.log('=====================================')
console.table({
  Version: version,
  Company: companyCode,
  DatabaseSuffix: databaseSuffix,
  Environment: import.meta.env.VITE_SPA_OSPREY_ENV || 'dev',
  Build: build,
  BuildTime: import.meta.env.VITE_SPA_OSPREY_TIMESTAMP || 'N/A', // this env var is set in CI/CD
  Branch: import.meta.env.VITE_SPA_OSPREY_GIT_BRANCH || 'N/A', // this env var is set in CI/CD,
  Commit: import.meta.env.VITE_SPA_OSPREY_GIT_COMMIT_HASH || 'N/A' // this env var is set in CI/CD,
})
console.log('=====================================')

mixpanelInit()

// initialize application insights if in production
AppInsightsInit(import.meta.env.VITE_SPA_OSPREY_APPLICATION_INSIGHTS_CONNECTION_STRING, version, build)

ReactDOM.createRoot(document.getElementById('reactroot')).render(
  <React.StrictMode>
    <Theme>
      <RouterProvider router={AppRouter(routes)} />
    </Theme>
  </React.StrictMode>
)
